import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { FacebookIcon, LinkedinIcon, EmailIcon, WhatsappIcon } from "react-share";

import SmsWidget from "../sms-widget/SmsWidget";
import MixpanelService from "shared/services/MixpanelService";

export default function ReactShare(props) {
  const { url, campaignId, smsText, twitterText } = props;
  const currentUrl = url || window.location.href;

  return (
    <ul className="share_list">
      <li>
        <a
          data-testid="t-ReactSh-share-on-facebook"
          href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`}
          target="blank"
          aria-label="Share on Facebook"
          onClick={() => MixpanelService.trackShareClick("Facebook")}>
          <FacebookIcon size={32} round={true} />
        </a>
      </li>
      <li>
        <a
          data-testid="t-ReactSh-share-on-linkedin"
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${currentUrl}`}
          target="blank"
          aria-label="Share on LinkedIn"
          onClick={() => MixpanelService.trackShareClick("LinkedIn")}>
          <LinkedinIcon size={32} round={true} />
        </a>
      </li>
      <li>
        <a
          data-testid="t-ReactSh-share-on-x"
          href={`https://twitter.com/intent/tweet?text=${twitterText}&url=${currentUrl}`}
          target="blank"
          aria-label="Share on X"
          onClick={() => MixpanelService.trackShareClick("X")}>
          <img
            src="/images/x.png"
            alt="X"
            width="30"
            height="30"
            className="no-vertical-align"
          />
        </a>
      </li>
      <li>
        <a
          data-testid="t-ReactSh-share-via-email"
          href={`mailto:?body=${currentUrl}`}
          aria-label="Share via Email"
          onClick={() => MixpanelService.trackShareClick("Email")}>
          <EmailIcon size={32} round={true} />
        </a>
      </li>
      <li>
        <a
          data-testid="t-ReactSh-share-via-whatsapp"
          href={`https://api.whatsapp.com/send?text=${twitterText} ${currentUrl}`}
          target="blank"
          aria-label="Share via Whatsapp"
          onClick={() => MixpanelService.trackShareClick("Whatsapp")}>
          <WhatsappIcon size={32} round={true} />
        </a>
      </li>
      <li>
        <SmsWidget shareText={smsText} campaignId={campaignId} />
      </li>
    </ul>
  );
}

ReactShare.propTypes = {
  url: PropTypes.string.isRequired,
  campaignId: PropTypes.string.isRequired,
  smsText: PropTypes.string.isRequired,
  twitterText: PropTypes.string.isRequired,
};
